module.exports = __webpack_public_path__ + "img/Screen-Shot-2017-09-06-at-6.57.58-PM.e6872ef2.jpg";